import { UserConfigService } from "@/services/user-config-service";
import { getPreloadsFromFilters, HumanFilter } from "@/utils/human-filter";
import { browseFieldPathToFilterFieldPath } from "@/utils/models/utils";
import { IQueryParams, IQueryParamsWithOptionalView } from "@/utils/query-params";
import { View } from "@/models/view";
import { Axios } from "../axios";
import { AxiosResponse } from "axios";
import { getModel, Model } from "../models/model";
import { BrowseService } from "@/services";

function processFilters(filters:HumanFilter[], model:Model):any[]{
	if (filters.length > 0) {
		filters[0].IsOr = false;
	}
	return filters.map(f=>f.getProcessedJson(model));
}

function getQuickFilters(query: IQueryParamsWithOptionalView):HumanFilter[] {
	if (query.searchQuery == "") return [];
	if (!query.view) return [];
	let browse = BrowseService.getBrowseWithoutViewSettings(query.view.BrowseID);
	let model:Model | null = null;
	if (browse){
		model = getModel(browse.Table);
	}
	if (query.searchByAllColumns) {
		return HumanFilter.getQuickFilters(query.view.Columns.filter(f => !f.IsComputed).map((c) => browseFieldPathToFilterFieldPath(c.Property)), query.searchQuery || "", model);
	}
	let settings = UserConfigService.getBrowseSearchSettings();
	let fields = settings.getSettings(query.view.BrowseID);
	return HumanFilter.getQuickFilters(fields, query.searchQuery || "", model);
}

export async function advancedSearch(query: IQueryParamsWithOptionalView, url: string, model:Model, additionalFilters:HumanFilter[] = [], additionalHeaders?:any):Promise<AxiosResponse> {
	let extraFilters = getQuickFilters(query);
	let filters = [...extraFilters, ...(query.filters || [])];
	if (additionalFilters.length > 0){
		if (filters.length > 0){
			filters[0].StartWhereGroup++;
			filters[filters.length-1].CloseWhereGroup++;
		}
		filters.push(...additionalFilters);
	}
	let preloads = getPreloadsFromFilters(filters);
	if (query.additionalPreloads){
		preloads.push(...query.additionalPreloads);
	}
	let params = {
		limit: query.limit,
		order: browseFieldPathToFilterFieldPath(query.orderBy),
		orderDirection: query.orderDirection,
		filters: processFilters(filters, model),
		preloads,
		offset: query.offset,
		searchQuery: query.searchQuery,
		autoWildCardSearch: query.autoWildCardSearch,
		searchByAllColumns: query.searchByAllColumns,
		dontSaveSettings: additionalFilters.length > 0 || query.dontSaveViewSettings ? "true" : "false"
	} as any;

	if (query.view) {
		url = `${url}/view/${query.view.ID}`;
	}

	let result = await Axios.get(url, {params, headers: additionalHeaders || {}});
	return result;
}

export async function advancedSearchStaticView(view:View, query: IQueryParams, url: string, additionalFilters:HumanFilter[] = [], additionalHeaders?:any, additionalPreloads?:any):Promise<AxiosResponse> {
	let extraFilters = getQuickFilters(query);

	view.computePreloads();
	let filters = [...extraFilters, ...(query.filters || [])];
	filters.push(...additionalFilters);
	let preloads = getPreloadsFromFilters(filters);
	if(additionalPreloads){
		preloads.push(...additionalPreloads);
	}

	let params = {
		limit: query.limit,
		order: browseFieldPathToFilterFieldPath(query.orderBy),
		orderDirection: query.orderDirection,
		filters: processFilters(filters, getModel(view.Table)),
		preloads,
		page: query.offset,
		searchQuery: query.searchQuery,
		autoWildCardSearch: query.autoWildCardSearch,
		dontSaveSettings: additionalFilters.length > 0 || query.dontSaveViewSettings ? "true" : "false",
		view: view.getJSON()
	} as any;

	let result = await Axios.get(`${url}`, {params, headers: additionalHeaders || {}});
	return result;
}
